import { useQuery } from '@tanstack/react-query';
import { api } from '../utils/api';

// Recent administrative activity for the organisation: sign-ins, account
// changes and configuration changes, from the audit trail.

interface DataEnvelope<T> {
  data: T;
}

export interface ActivityActor {
  id: number | null;
  username: string;
}

export interface ActivityEvent {
  id: number;
  /** Event code, e.g. login_success, user_deactivated, sso_config_changed. */
  event: string;
  /** ISO timestamp. */
  at: string;
  /** Who did it (null for anonymous events such as a failed sign-in). */
  actor: ActivityActor | null;
  reason: string;
  /** Event-specific detail, e.g. target_username for account changes. */
  extra: Record<string, unknown>;
}

export const useActivity = (limit = 20) =>
  useQuery({
    queryKey: ['admin-activity', limit],
    queryFn: async () => {
      const res = await api.request<DataEnvelope<ActivityEvent[]>>(
        `/api/admin/activity?limit=${limit}`
      );
      return res.data;
    },
    staleTime: 30 * 1000,
  });
